/* eslint-disable @typescript-eslint/explicit-function-return-type */

export async function importPizZip() {
	return (await import("pizzip")).default;
}

export function loadDependencies(): void {
	window.setTimeout(() => {
		void importPizZip();
	}, 1000);
}
